import styled from "styled-components";
import { breakpoints } from "./breakpoints";

export const Container = styled.div`
  margin: ${props => (props.mobilePadding ? "0 15px" : "0")};
  max-width: ${breakpoints.xl}px;

  @media (min-width: ${breakpoints.lg}px) {
    margin: 0 40px;
  }

  @media (min-width: ${breakpoints.xl}px) {
    margin: 0 auto;
  }
`;

export const TextContainer = styled.div`
  margin: 0 15px;

  @media (min-width: ${breakpoints.lg}px) {
    margin: 0;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Grid/Container.js